import React from "react";
import {useMutation} from "react-query";
import Alert from "react-s-alert";
import {useFormikContext} from "formik";
import {Button} from "@reside/ui";
import {ButtonLink} from "../../../atoms/button-link";
import {
  HubAndSpokeService,
  SftpConfig,
} from "../../../services/HubAndSpokeService";
import {FooterActions, FormFooter} from "../styles";

export const SftpConfigFormFooter = () => {
  const {values, submitForm} = useFormikContext<SftpConfig>();

  const {mutate, isLoading} = useMutation(HubAndSpokeService.testConnectivity, {
    onSuccess: () => {
      Alert.success("Connection successful.");
    },
    onError: (error: any) => {
      Alert.error(error.data.detail);
    },
  });

  return (
    <FormFooter>
      <Button
        onClick={() =>
          mutate({
            hostname: values.hostname,
            port: values.port,
            username: values.username,
            auth_type: values.auth_type,
            auth_value: values.auth_value,
          })
        }
        color="primary"
        outline
        disabled={isLoading || !values.hostname || !values.auth_value}
      >
        {isLoading ? "Connecting..." : "Test connectivity"}
      </Button>
      <FooterActions>
        <ButtonLink
          to="/admin/hub-and-spoke/sftp-configurations"
          disabled={isLoading}
        >
          Cancel
        </ButtonLink>
        <Button onClick={submitForm} color="primary" disabled={isLoading}>
          Save
        </Button>
      </FooterActions>
    </FormFooter>
  );
};
